import React from 'react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { GuestCategoryDisplayTypeEnum } from '@app/enums';

const DISPLAY_TYPE_TO_ICON_COMPONENT: Record<
    GuestCategoryDisplayTypeEnum,
    React.ComponentType<{ size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }>
> = {
    [GuestCategoryDisplayTypeEnum.Business]: IconsLinear.Business,
    [GuestCategoryDisplayTypeEnum.Solo]: IconsLinear.Solo,
    [GuestCategoryDisplayTypeEnum.Couple]: IconsLinear.Couple,
    [GuestCategoryDisplayTypeEnum.Family]: IconsLinear.Family,
    [GuestCategoryDisplayTypeEnum.Friends]: IconsLinear.Friends,
};

/**
 * Returns the appropriate icon component for a guest category display type
 * @param props - Object containing type and optional size
 * @returns JSX icon element or null
 */
export const getGuestCategoryIcon = ({
    type,
    size = 'xs',
}: {
    type: GuestCategoryDisplayTypeEnum;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}) => {
    const IconComponent = DISPLAY_TYPE_TO_ICON_COMPONENT[type];
    return IconComponent ? <IconComponent size={size} /> : null;
};
